import { RequestQueue } from "@/components/staffing-requests/RequestQueue";

export function StaffingRequestsPage() {
  return <RequestQueue />;
}
